import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getSeoForPath, shouldNoIndexPath } from './seoRegistry';
import { getSiteOrigin } from './siteOrigin';

const ORG_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Horse Racing Oracle',
  url: 'https://app.horseracingoracle.com',
};

export default function RouteSeo() {
  const { pathname } = useLocation();
  const origin = getSiteOrigin();
  const canonicalUrl = `${origin}${pathname === '/' ? '' : pathname}`;
  const seo = getSeoForPath(pathname);
  const noIndex = shouldNoIndexPath(pathname);

  return (
    <Helmet prioritizeSeoTags>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {noIndex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      {pathname === '/' && (
        <script type="application/ld+json">{JSON.stringify(ORG_JSON_LD)}</script>
      )}
    </Helmet>
  );
}
